import { connect } from 'react-redux';
import LocalVideo from 'shared/components/VideoConference/LocalVideo';
import { isCurrentConversationMCU } from 'modules/appointmentInfo/selectors/currentAppointment';

import { setVideoLayout } from '../../actions/setVideoLayout';
import { setSelfAudioStatus } from '../../actions/setSelfAudioStatus';
import { setSelfVideoStatus } from '../../actions/setSelfVideoStatus';
import { localVideoConnected } from '../../selectors/connectionStatus';
import {
  getVideoMediaStream,
  toggleAudioMute,
  toggleVideoMute,
} from '../../actions/videoConsultation';


const mapStateToProps = (state) => ({
  isMCU: isCurrentConversationMCU(state),
  localVideoConnected: localVideoConnected(state),
  videoDisabled: state.conference.remoteMedia.videoDisabled,
  isSwitched: state.conference.consultationInfo.switchedLayout,
  isAudioMuted: state.conference.consultationInfo.selfAudioOff,
  isVideoMuted: state.conference.consultationInfo.selfVideoOff,
});

const mapDispatchToProps = (dispatch) => ({
  getMediaStream: () => dispatch(getVideoMediaStream(true)),
  setVideoLayout: (value) => dispatch(setVideoLayout(value)),
  muteAudio: () => [
    dispatch(setSelfAudioStatus(true)),
    dispatch(toggleAudioMute(true)),
  ],
  unmuteAudio: () => [
    dispatch(setSelfAudioStatus(false)),
    dispatch(toggleAudioMute(false)),
  ],

  muteVideo: () => [
    dispatch(setSelfVideoStatus(true)),
    dispatch(toggleVideoMute(true)),
  ],
  unmuteVideo: () => [
    dispatch(setSelfVideoStatus(false)),
    dispatch(toggleVideoMute(false)),
  ],
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LocalVideo);
